import { React, useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Search, Select, XCircle, MTable, MLink, Text, Dropdown } from "@cisco/spaces-dash-lib-styleguide";
import { NodeContext } from "../../contexts/nodeContext";
import * as BusinessHierarchyService from "../../service/business-hierarchy-service";
import CameraEmpty from "../../assets/images/location-accesspoints/camera_empty_lh2.svg";
import { I18nContext } from "../../contexts/i18nContext";
import useLoader from "../../hooks/useLoader";
import "../../common/common_style.scss";
import "../../common/global_style.scss";
import "./location-sensors.scss";

function LocationSensors(props) {
  const i18n = useContext(I18nContext);
  const navigate = useNavigate();
  const { node, sensorCount, locationRowMap } = useContext(NodeContext);
  const { setLoading } = useLoader();
  const [locationNode] = useState({ ...node });
  const [sensorListState, setSensorListState] = useState([]);
  const [sensorListFilteredState, setSensorListFilteredState] = useState([]);
  const [sensorListPagedState, setSensorListPagedState] = useState([]);
  const searchText = useRef("");
  const [type, setType] = useState("all");
  const totalNoOfItems = useRef(sensorCount);
  const [ftotalNoOfItems, setFotalNoOfItems] = useState(sensorCount);
  const [showTable, setShowTable] = useState(false);
  // const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageRef = useRef(10);
  const [paginationKey, setPaginationKey] = useState(0);

  let sensorList = [];
  let sensorListFILTERED = [];
  let sensorListPaged = [];
  totalNoOfItems.current = sensorCount;

  const getStart = (currentPage) => {
    return currentPage * rowsPerPageRef.current;
  };

  const getEnd = (currentPage) => {
    return currentPage * rowsPerPageRef.current + rowsPerPageRef.current;
  };

  const refreshPaginator = () => {
    setPageNumber(0);
    setRowsPerPage(rowsPerPageRef.current);
    sensorListPaged = sensorListFILTERED;
    setSensorListPagedState(sensorListPaged);
  };

  const refreshPaginatorForSearch = () => {
    setPageNumber(0);
    setRowsPerPage(10);
    setRowsPerPage(rowsPerPageRef.current);
    sensorListPaged = sensorListFILTERED;
    setSensorListPagedState(sensorListPaged);
  };

  const processSearchSensorListResponse = (response) => {
    if (response.status) {
      sensorList = response.data;
      totalNoOfItems.current = sensorList.length;
      if (sensorList.length < rowsPerPage || sensorList.length > rowsPerPage) {
        setFotalNoOfItems(sensorList.length);
      } else {
        setFotalNoOfItems(sensorCount);
      }
      setSensorListState(sensorList);
      if (sensorList && sensorList.length > 0) {
        sensorList.forEach((apObj, index) => {
          const { id: apLocId, name: apLocName } = apObj.locationDetails;
          const apLocData = locationRowMap[apLocId];

          if (apLocData) {
            // Create a new locationDetails object
            const newLocationDetails = { ...apObj.locationDetails };

            if (apLocData.parentId === locationNode.id) {
              newLocationDetails.name = `${locationNode.name}/${apLocName}`;
            } else {
              newLocationDetails.name = `${locationNode.name}/..../${apLocName}`;
            }

            // Update the original sensorList
            sensorList[index] = { ...apObj, locationDetails: newLocationDetails };
          }
        });
      }
    } else {
      sensorList = [];
      setSensorListState([]);
      setFotalNoOfItems(0);
    }
    sensorListFILTERED = sensorList;
    setSensorListFilteredState(sensorListFILTERED);
  };

  const processSensorListResponseInitial = (response) => {
    if (response.status) {
      sensorList = response.data;
      totalNoOfItems.current = sensorList.length;
      setSensorListState(sensorList);
      if (sensorCount <= rowsPerPage && sensorCount != sensorList.length) {
        setFotalNoOfItems(sensorList.length);
        totalNoOfItems.current = sensorList.length;
      } else {
        setFotalNoOfItems(sensorCount);
      }
      if (sensorList && sensorList.length > 0) {
        sensorList.forEach((apObj, index) => {
          const { id: apLocId, name: apLocName } = apObj.locationDetails;
          const apLocData = locationRowMap[apLocId];

          if (apLocData) {
            // Create a new locationDetails object
            const newLocationDetails = { ...apObj.locationDetails };

            if (apLocData.parentId === locationNode.id) {
              newLocationDetails.name = `${locationNode.name}/${apLocName}`;
            } else {
              newLocationDetails.name = `${locationNode.name}/..../${apLocName}`;
            }

            // Update the original sensorList
            sensorList[index] = { ...apObj, locationDetails: newLocationDetails };
          }
        });
      }
    } else {
      sensorList = [];
      setSensorListState([]);
    }
    sensorListFILTERED = sensorList;
    setSensorListFilteredState(sensorListFILTERED);
  };

  const processSensorListResponse = (response) => {
    if (response.status) {
      sensorList = response.data;
      totalNoOfItems.current = sensorList.length;
      setSensorListState(sensorList);
      if (sensorList && sensorList.length > 0) {
        sensorList.forEach((apObj, index) => {
          const { id: apLocId, name: apLocName } = apObj.locationDetails;
          const apLocData = locationRowMap[apLocId];

          if (apLocData) {
            // Create a new locationDetails object
            const newLocationDetails = { ...apObj.locationDetails };

            if (apLocData.parentId === locationNode.id) {
              newLocationDetails.name = `${locationNode.name}/${apLocName}`;
            } else {
              newLocationDetails.name = `${locationNode.name}/..../${apLocName}`;
            }

            // Update the original sensorList
            sensorList[index] = { ...apObj, locationDetails: newLocationDetails };
          }
        });
      }
    } else {
      sensorList = [];
      setSensorListState([]);
    }
    sensorListFILTERED = sensorList;
    setSensorListFilteredState(sensorListFILTERED);
  };

  const showSearchEmptyState = () => {
    if (searchText.current && searchText.current.length > 0 && sensorListPaged.length === 0) {
      return true;
    }
    return false;
  };

  const searchSensorList = (currentPageNo = 0, typeSelected = type, search = searchText.current, end = sensorCount) => {
    setLoading(true);
    BusinessHierarchyService.getSensorsList(locationNode.id, typeSelected, getStart(currentPageNo), end, search)
      .then((response) => {
        setLoading(false);
        processSearchSensorListResponse(response);
        if (currentPageNo == 1) {
          refreshPaginatorForSearch();
        } else {
          sensorListPaged = sensorListFILTERED;
          setSensorListPagedState(sensorListPaged);
        }
      })
      .catch((error) => {
        setLoading(false);
        setSensorListState([]);
        sensorList = [];
        setSensorListFilteredState([]);
        sensorListFILTERED = [];
        refreshPaginatorForSearch();
        console.log(`Location Sensors: Error on getSensorList${error}`);
      });
  };

  const onTypeChange = (value) => {
    searchText.current = "";
    totalNoOfItems.current = sensorCount;
    setPageNumber(0);
    setRowsPerPage(10);
    rowsPerPageRef.current = 10;
    setFotalNoOfItems(sensorCount);
    setShowTable(true);
    if (value) {
      setType(value);
      searchSensorList(0, value, "", rowsPerPage);
    }
  };

  const filterValue = (event) => {
    searchText.current = event.target.value;
    totalNoOfItems.current = sensorCount;
    setFotalNoOfItems(sensorCount);
    searchSensorList(0, type, event.target.value, sensorCount);
  };
  const navigateTo = (link) => {
    switch (link) {
      case "pdu":
        navigate("/setup/sensors");
        break;
      case "signage":
        navigate("/setup/sensors");
        break;
      case "iot":
        navigate("/devices/device_management");
        break;
      default:
        navigate("/setup/sensors");
    }
  };

  const getSensorList = (currentPageNo = 0, typeSelected = type, search = searchText.current) => {
    setLoading(true);
    BusinessHierarchyService.getSensorsList(locationNode.id, typeSelected, getStart(currentPageNo), getEnd(currentPageNo), search)
      .then((response) => {
        setLoading(false);
        processSensorListResponse(response);
        if (currentPageNo == 1) {
          refreshPaginator();
        } else {
          sensorListPaged = sensorListFILTERED;
          setSensorListPagedState(sensorListPaged);
        }
      })
      .catch((error) => {
        setLoading(false);
        setSensorListState([]);
        sensorList = [];
        setSensorListFilteredState([]);
        sensorListFILTERED = [];
        refreshPaginator();
        console.log(`Location Sensors: Error on getSensorList${error}`);
      });
  };

  const onPageChange = (event) => {
    sensorListFILTERED = sensorListFilteredState;
    setShowTable(true);
    getSensorList(event, type);
  };

  const clearSearch = () => {
    searchText.current = "";
    setPageNumber(0);
    setRowsPerPage(10);
    rowsPerPage.current = 10;
    totalNoOfItems.current = sensorCount;
    setFotalNoOfItems(sensorCount);
    getSensorList(1, type, "");
  };

  const initialSensorList = (currentPageNo = 0, typeSelected = type) => {
    searchText.current = "";
    setLoading(true);
    BusinessHierarchyService.getSensorsList(locationNode.id, typeSelected, getStart(currentPageNo), getEnd(currentPageNo), searchText.current)
      .then((response) => {
        setLoading(false);
        if (response && response.data && response.data.length > 0) {
          setShowTable(true);
        }
        processSensorListResponseInitial(response);
        if (currentPageNo == 1) {
          refreshPaginator();
        } else {
          sensorListPaged = sensorListFILTERED;
          setSensorListPagedState(sensorListPaged);
        }
      })
      .catch((error) => {
        setLoading(false);
        setSensorListState([]);
        sensorList = [];
        setSensorListFilteredState([]);
        sensorListFILTERED = [];
        refreshPaginator();
        console.log(`Location Sensors: Error on getSensorList${error}`);
      });
  };

  useEffect(() => {
    console.log("LocationSensors Mount");
    console.log(`${props} : ${sensorListState}`);
    if (sensorCount && sensorCount > 0) {
      initialSensorList();
    }

    return () => {
      console.log("LocationSensors Destroy");
    };
  }, []);

  useEffect(() => {
    setPaginationKey(paginationKey + 1);
  }, [sensorListPagedState]);

  return (
    <div className="ap-wrapper boxShadowBlur" id="linked-devices-wrapper">
      <Flex direction="vertical" gap={16}>
        <Flex align="center" justify="space-between" gap={8} />
        {showTable && sensorListPagedState && sensorListPagedState.length >= 0 && (
          <>
            <Text color="light" size="p3" weight="regular">
              {i18n.t("location-sensors.devices-linked-text-desc")}
            </Text>
            <Flex align="center" justify="space-between">
              <Flex justify="space-between" gap={15}>
                <Flex direction="vertical">
                  <Search
                    label=""
                    placeholder={i18n.t("proximity-rule.search-text")}
                    options={[]}
                    onChange={filterValue}
                    value={searchText.current}
                    suffix={searchText.current.length > 0 && <XCircle size={18} onClick={clearSearch} />}
                  />
                </Flex>
                <Flex direction="vertical">
                  <Select
                    style={{ width: "120px" }}
                    fixedWidth
                    onChange={onTypeChange}
                    options={[
                      {
                        label: i18n.t("location-sensors.all-text"),
                        value: "all"
                      },
                      {
                        label: i18n.t("location-sensors.iot-devices-text"),
                        value: "iot"
                      },
                      {
                        label: i18n.t("location-sensors.non-webex-signages-text"),
                        value: "signage"
                      },
                      {
                        label: i18n.t("location-sensors.pdus-text"),
                        value: "pdu"
                      }
                    ]}
                    placeholder={i18n.t("location-sensors.select-type-text")}
                    value={type}
                  />
                </Flex>
              </Flex>
              <Flex justify="space-between">
                <Flex align="center">
                  {showTable && sensorListPagedState && sensorListPagedState.length >= 0 && (
                    // <Popover
                    //   open={isPopoverOpen}
                    //   placement="bottom"
                    //   title={
                    //     <Flex direction="vertical">
                    //       <Text
                    //         color="light"
                    //         onClick={() => {
                    //           navigateTo("iot");
                    //         }}
                    //         style={{ cursor: "pointer", padding: "5px" }}
                    //         size="p2"
                    //       >
                    //         {i18n.t("location-sensors.iot-devices-text")}
                    //       </Text>
                    //       <Text
                    //         color="light"
                    //         onClick={() => {
                    //           navigateTo("signage");
                    //         }}
                    //         style={{ cursor: "pointer", padding: "5px" }}
                    //         size="p2"
                    //       >
                    //         {i18n.t("location-sensors.non-webex-signages-text")}
                    //       </Text>
                    //       <Text
                    //         color="light"
                    //         onClick={() => {
                    //           navigateTo("pdu");
                    //         }}
                    //         style={{ cursor: "pointer", padding: "5px" }}
                    //         size="p2"
                    //       >
                    //         {i18n.t("location-sensors.pdus-text")}
                    //       </Text>
                    //     </Flex>
                    //   }
                    //   kind="default"
                    // >
                    //   <MLink
                    //     className="click-target"
                    //     onClick={() => {
                    //       setIsPopoverOpen((isPopoverOpened) => !isPopoverOpened);
                    //     }}
                    //   >
                    //     {i18n.t("location-sensors.on-board-devices-text")}
                    //   </MLink>
                    // </Popover>
                    <Dropdown kind="tertiary" title={i18n.t("location-sensors.on-board-devices-text")} label={i18n.t("location-sensors.on-board-devices-text")}>
                      <Dropdown.Item
                        onClick={() => {
                          navigateTo("iot");
                        }}
                        label={i18n.t("location-sensors.iot-devices-text")}
                      />
                      <Dropdown.Item
                        onClick={() => {
                          navigateTo("signage");
                        }}
                        label={i18n.t("location-sensors.non-webex-signages-text")}
                      />
                      <Dropdown.Item
                        onClick={() => {
                          navigateTo("pdu");
                        }}
                        label={i18n.t("location-sensors.pdus-text")}
                      />
                    </Dropdown>
                  )}
                </Flex>
              </Flex>
            </Flex>
          </>
        )}
        {showTable && sensorListPagedState && sensorListPagedState.length >= 0 && (
          <div className="userTableContainer">
            <MTable.Pagination
              currentPage={pageNumber + 1}
              paginationKey={paginationKey}
              key={sensorListPagedState.length}
              defaultRecordsOption={rowsPerPageRef.current}
              kind={
                searchText.current && searchText.current != ""
                  ? "client"
                  : {
                      server: {
                        rowCount: ftotalNoOfItems,
                        onPageChange: (currentPage) => {
                          setPageNumber(currentPage);
                          onPageChange(currentPage);
                        },
                        onRowsPerPageChange: (change) => {
                          rowsPerPageRef.current = change;
                          setRowsPerPage(change);
                          getSensorList(0);
                        }
                      }
                    }
              }
              showNavigation="all"
              showOptions
              showTotal
            >
              <MTable
                columns={[
                  {
                    accessorKey: "name",
                    header: i18n.t("location-sensors.sensor-name"),
                    meta: {
                      align: "left"
                    },
                    enableSorting: true
                  },
                  {
                    accessorKey: "macAddress",
                    header: i18n.t("business-location-details.mac-address-text"),
                    meta: {
                      align: "left"
                    },
                    enableSorting: true
                  }
                ]}
                data={sensorListPagedState}
              />
            </MTable.Pagination>
          </div>
        )}
        {!showTable && showSearchEmptyState() && (
          <div className="divTable empty_wrapper">
            <div className="divTableRow">
              <div className="divTableCell width50_middle">
                <div className="title">{i18n.t("location-sensors.no-sensor-matching")}</div>
                <div className="desc">{i18n.t("location-sensors.configure-sensor-setup")}</div>
              </div>
              <div className="divTableCell width50_middle">
                <div>
                  <img className="team-empty-img" src={CameraEmpty} alt="camera" />
                </div>
              </div>
            </div>
          </div>
        )}
        {!showTable && (!searchText.current || searchText.current.length == 0) && sensorListPagedState.length == 0 && (
          <div className="team-empty-business">
            <div className="divTable empty_wrapper" id="network-linked-device">
              <div className="divTableRow">
                <div className="divTableCell width50_middle">
                  <div className="title">
                    <Text size="p1" weight="bold">
                      {i18n.t("location-sensors.no-linked-devices-for-location-text")}
                    </Text>
                  </div>
                  <div className="desc">
                    <Text size="p2" weight="regular" color="light">
                      {i18n.t("location-sensors.your-linked")}
                      <MLink
                        onClick={() => {
                          navigateTo("iot");
                        }}
                        size="md"
                      >
                        {i18n.t("location-sensors.iot-devices-text")}
                      </MLink>
                      ,{" "}
                      <MLink
                        onClick={() => {
                          navigateTo("signage");
                        }}
                        size="md"
                      >
                        {i18n.t("location-sensors.non-webex-signages-text")}
                      </MLink>{" "}
                      &{" "}
                      <MLink
                        onClick={() => {
                          navigateTo("pdu");
                        }}
                        size="md"
                      >
                        {i18n.t("location-sensors.smart-pdus")}
                      </MLink>
                      {i18n.t("location-sensors.will-appear-text")}
                    </Text>
                  </div>
                </div>
                <div className="divTableCell width50_middle">
                  <div>
                    <img className="team-empty-img" src={CameraEmpty} alt="camera" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Flex>
    </div>
  );
}

export default LocationSensors;
